// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Error Boundary Styles
 * Modern, user-friendly error display
 */

.error-boundary {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.1) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.error-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  max-width: 600px;
  width: 100%;
  text-align: center;
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 8px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.error-icon {
  color: #e53e3e;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.error-content h1 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
}

.error-content p {
  color: #4a5568;
  font-size: 1.1rem;
  margin-bottom: 24px;
  line-height: 1.6;
}

.error-id {
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 24px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9rem;
  color: #2d3748;
}

.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.error-button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.error-button.primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.error-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.error-button.secondary {
  background: rgba(255, 255, 255, 0.9);
  color: #4a5568;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.error-button.secondary:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
  transform: translateY(-1px);
}

.error-details {
  margin-top: 32px;
  text-align: left;
}

.error-details-toggle {
  background: none;
  border: none;
  color: #0D3B66;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0;
  text-decoration: underline;
}

.error-details-toggle:hover {
  color: #5a67d8;
}

.error-details-content {
  margin-top: 16px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
}

.error-details-content h3,
.error-details-content h4 {
  color: #2d3748;
  margin-bottom: 8px;
  font-size: 1rem;
}

.error-stack {
  background: #1a202c;
  color: #e2e8f0;
  padding: 16px;
  border-radius: 6px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.8rem;
  line-height: 1.4;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 16px;
}

.error-component-stack {
  margin-top: 16px;
}

.error-component-stack h4 {
  color: #4a5568;
  font-size: 0.9rem;
  margin-bottom: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .error-boundary {
    padding: 16px;
  }

  .error-container {
    padding: 24px;
  }

  .error-content h1 {
    font-size: 1.5rem;
  }

  .error-content p {
    font-size: 1rem;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .error-button {
    width: 100%;
    max-width: 200px;
  }

  .error-stack {
    font-size: 0.7rem;
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .error-container {
    padding: 20px;
  }

  .error-content h1 {
    font-size: 1.25rem;
  }

  .error-icon svg {
    width: 48px;
    height: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ErrorBoundary.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;qDAGmD;EACnD,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;EACxD,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,wDAAwD;EACxD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/**\n * Error Boundary Styles\n * Modern, user-friendly error display\n */\n\n.error-boundary {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.1) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 20px;\n}\n\n.error-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  text-align: center;\n  box-shadow:\n    0 20px 40px rgba(0, 0, 0, 0.1),\n    0 8px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.error-icon {\n  color: #e53e3e;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n}\n\n.error-content h1 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 16px;\n  line-height: 1.2;\n}\n\n.error-content p {\n  color: #4a5568;\n  font-size: 1.1rem;\n  margin-bottom: 24px;\n  line-height: 1.6;\n}\n\n.error-id {\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.9rem;\n  color: #2d3748;\n}\n\n.error-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 32px;\n}\n\n.error-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n}\n\n.error-button.primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.error-button.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n}\n\n.error-button.secondary {\n  background: rgba(255, 255, 255, 0.9);\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.error-button.secondary:hover {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n  transform: translateY(-1px);\n}\n\n.error-details {\n  margin-top: 32px;\n  text-align: left;\n}\n\n.error-details-toggle {\n  background: none;\n  border: none;\n  color: #0D3B66;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 8px 0;\n  text-decoration: underline;\n}\n\n.error-details-toggle:hover {\n  color: #5a67d8;\n}\n\n.error-details-content {\n  margin-top: 16px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.error-details-content h3,\n.error-details-content h4 {\n  color: #2d3748;\n  margin-bottom: 8px;\n  font-size: 1rem;\n}\n\n.error-stack {\n  background: #1a202c;\n  color: #e2e8f0;\n  padding: 16px;\n  border-radius: 6px;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-bottom: 16px;\n}\n\n.error-component-stack {\n  margin-top: 16px;\n}\n\n.error-component-stack h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  margin-bottom: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .error-boundary {\n    padding: 16px;\n  }\n\n  .error-container {\n    padding: 24px;\n  }\n\n  .error-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .error-content p {\n    font-size: 1rem;\n  }\n\n  .error-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .error-button {\n    width: 100%;\n    max-width: 200px;\n  }\n\n  .error-stack {\n    font-size: 0.7rem;\n    padding: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .error-container {\n    padding: 20px;\n  }\n\n  .error-content h1 {\n    font-size: 1.25rem;\n  }\n\n  .error-icon svg {\n    width: 48px;\n    height: 48px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
